import React, { useEffect, useState } from "react";
import cx from 'classnames';
import _ from "lodash";
import styles from "./groupIcon.module.scss";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Thumbnail from "../thumbnail";
import type { Group } from "src/types/groups";

interface GroupProps {
  group?: Group;
  view?: string;
  isEditStream?: boolean;
  hoveredEntity?: string;
  handleGroupClick?: (group: Group) => void;
  isGroupSelected?: (group: Group) => boolean;

}

const GroupIcon: React.FC<GroupProps> = ({ group, view, isEditStream, hoveredEntity, handleGroupClick, isGroupSelected }) => {

  return (
    <div className={cx(styles.container, view && styles[view], {
      [styles.selectedGroup]: group && isGroupSelected? isGroupSelected(group) : false,
      [styles.hoveredContainer]: hoveredEntity ? group?.id === hoveredEntity : false,
    })}
    onClick={() => group && handleGroupClick && handleGroupClick(group)}
    >
      <div className={cx(styles.groupIconWrapper, view && styles[view])}> </div>
      <div className={cx(styles.radioWrapper, {
        [styles[`editStream-${view}`]]: isEditStream,
      })}>
        <i className={cx({
          "paperflite-radio-button-unselected": group && isGroupSelected ? !isGroupSelected(group) : false,
          "fa-solid fa-check-circle": group && isGroupSelected ? isGroupSelected(group) : false
        })}></i>
      </div>
      <div className={cx(styles.iconWrapper, view && styles[view], {
        [styles[`editStream-${view}`]]: isEditStream,
      })}>
        <Thumbnail
          media={group?.icon}
          width={260}
          className={cx(styles.thumbnail, view && styles[view])}
          alt=""
          defaultImage="/images/assets/default_asset.jpg"
        />
      </div>
    </div>
  );
};

export default GroupIcon;
